/* Grid view */
function collectionChangeMode() {
  function setCookie(cname, cvalue, exdays) {
    var current_domain = window.location.host;

    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + "; " + expires + ";domain=." + current_domain + ";path=/";
  }

  function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1);
      if (c.indexOf(name) != -1) return c.substring(name.length, c.length);

    }
    return null;
  }

  $(".change_mode_new").on('click',function(e) {
    if ($(this).hasClass("active") == true) {
      console.log("Light");
      $(this).find(".change_mode_text_new").text("SET THE MOOD");
      $(this).removeClass('active');
      $('body').removeClass("collection_dark_mode");
      setCookie('select-view', 'light', '365');
    }
    else
    {
      console.log("Dark");
      $(this).addClass('active');
      $(this).find(".change_mode_text_new").text("LIGHTS ON");
      $('body').addClass("collection_dark_mode");
      setCookie('select-view', 'dark', '365');
    }
  })

  if (!getCookie('select-view')) {
    setCookie('select-view', 'light', '365');
    console.log(getCookie('select-view'));
  }
  if (getCookie('select-view') == 'dark') {
    $('.change_mode_new').addClass("active");
    $('body').addClass("collection_dark_mode");
    setCookie('select-view', 'dark', '365');
  }
  if (getCookie('select-view') == 'light') {
    $('.change_mode_new').removeClass("active");
    $('body').removeClass("collection_dark_mode");
    setCookie('select-view', 'light', '365');
  }
}
collectionChangeMode()
document.addEventListener('collectionChangeMode:init', collectionChangeMode);


/* marquee  */
(function(factory){"use strict";if(typeof define==="function"&&define.amd){define(["jquery"],factory)}else if(typeof exports!=="undefined"){module.exports=factory(require("jquery"))}else{factory(jQuery)}})(function($){$.fn.marquee=function(options){return this.each(function(){var o=$.extend({},$.fn.marquee.defaults,options),$this=$(this),$marqueeWrapper,containerWidth,animationCss,verticalDir,elWidth,loopCount=3,playState="animation-play-state",css3AnimationIsSupported=false,_prefixedEvent=function(element,type,callback){var pfx=["webkit","moz","MS","o",""];for(var p=0;p<pfx.length;p++){if(!pfx[p])type=type.toLowerCase();element.addEventListener(pfx[p]+type,callback,false)}},_objToString=function(obj){var tabjson=[];for(var p in obj){if(obj.hasOwnProperty(p)){tabjson.push(p+":"+obj[p])}}tabjson.push();return"{"+tabjson.join(",")+"}"},_startAnimationWithDelay=function(){$this.timer=setTimeout(animate,o.delayBeforeStart)},methods={pause:function(){if(css3AnimationIsSupported&&o.allowCss3Support){$marqueeWrapper.css(playState,"paused")}else{if($.fn.pause){$marqueeWrapper.pause()}}$this.data("runningStatus","paused");$this.trigger("paused")},resume:function(){if(css3AnimationIsSupported&&o.allowCss3Support){$marqueeWrapper.css(playState,"running")}else{if($.fn.resume){$marqueeWrapper.resume()}}$this.data("runningStatus","resumed");$this.trigger("resumed")},toggle:function(){methods[$this.data("runningStatus")==="resumed"?"pause":"resume"]()},destroy:function(){clearTimeout($this.timer);$this.find("*").addBack().off();$this.html($this.find(".js-marquee:first").html())}};if(typeof options==="string"){if($.isFunction(methods[options])){if(!$marqueeWrapper){$marqueeWrapper=$this.find(".js-marquee-wrapper")}if($this.data("css3AnimationIsSupported")===true){css3AnimationIsSupported=true}methods[options]()}return}var dataAttributes={},attr;$.each(o,function(key){attr=$this.attr("data-"+key);if(typeof attr!=="undefined"){switch(attr){case"true":attr=true;break;case"false":attr=false;break}o[key]=attr}});if(o.speed){o.duration=parseInt($this.width(),10)/o.speed*1e3}verticalDir=o.direction==="up"||o.direction==="down";o.gap=o.duplicated?parseInt(o.gap):0;$this.wrapInner('<div class="js-marquee"></div>');var $el=$this.find(".js-marquee").css({"margin-right":o.gap,float:"left"});if(o.duplicated){$el.clone(true).appendTo($this)}$this.wrapInner('<div style="width:100000px" class="js-marquee-wrapper"></div>');$marqueeWrapper=$this.find(".js-marquee-wrapper");if(verticalDir){var containerHeight=$this.height();$marqueeWrapper.removeAttr("style");$this.height(containerHeight);$this.find(".js-marquee").css({float:"none","margin-bottom":o.gap,"margin-right":0});if(o.duplicated){$this.find(".js-marquee:last").css({"margin-bottom":0})}var elHeight=$this.find(".js-marquee:first").height()+o.gap;if(o.startVisible&&!o.duplicated){o._completeDuration=(parseInt(elHeight,10)+parseInt(containerHeight,10))/parseInt(containerHeight,10)*o.duration;o.duration=parseInt(elHeight,10)/parseInt(containerHeight,10)*o.duration}else{o.duration=(parseInt(elHeight,10)+parseInt(containerHeight,10))/parseInt(containerHeight,10)*o.duration}}else{elWidth=$this.find(".js-marquee:first").width()+o.gap;containerWidth=$this.width();if(o.startVisible&&!o.duplicated){o._completeDuration=(parseInt(elWidth,10)+parseInt(containerWidth,10))/parseInt(containerWidth,10)*o.duration;o.duration=parseInt(elWidth,10)/parseInt(containerWidth,10)*o.duration}else{o.duration=(parseInt(elWidth,10)+parseInt(containerWidth,10))/parseInt(containerWidth,10)*o.duration}}if(o.duplicated){o.duration=o.duration/2}if(o.allowCss3Support){var elm=document.body||document.createElement("div"),animationName="marqueeAnimation-"+Math.floor(Math.random()*1e7),domPrefixes="Webkit Moz O ms Khtml".split(" "),animationString="animation",animationCss3Str="",keyframeString="";if(elm.style.animation!==undefined){keyframeString="@keyframes "+animationName+" ";css3AnimationIsSupported=true}if(css3AnimationIsSupported===false){for(var i=0;i<domPrefixes.length;i++){if(elm.style[domPrefixes[i]+"AnimationName"]!==undefined){var prefix="-"+domPrefixes[i].toLowerCase()+"-";animationString=prefix+animationString;playState=prefix+playState;keyframeString="@"+prefix+"keyframes "+animationName+" ";css3AnimationIsSupported=true;break}}}if(css3AnimationIsSupported){animationCss3Str=animationName+" "+o.duration/1e3+"s "+o.delayBeforeStart/1e3+"s infinite "+o.css3easing;$this.data("css3AnimationIsSupported",true)}}var _rePositionVertically=function(){$marqueeWrapper.css("transform","translateY("+(o.direction==="up"?containerHeight+"px":"-"+elHeight+"px")+")")},_rePositionHorizontally=function(){$marqueeWrapper.css("transform","translateX("+(o.direction==="left"?containerWidth+"px":"-"+elWidth+"px")+")")};if(o.duplicated){if(verticalDir){if(o.startVisible){$marqueeWrapper.css("transform","translateY(0)")}else{$marqueeWrapper.css("transform","translateY("+(o.direction==="up"?containerHeight+"px":"-"+(elHeight*2-o.gap)+"px")+")")}}else{if(o.startVisible){$marqueeWrapper.css("transform","translateX(0)")}else{$marqueeWrapper.css("transform","translateX("+(o.direction==="left"?containerWidth+"px":"-"+(elWidth*2-o.gap)+"px")+")")}}if(!o.startVisible){loopCount=1}}else if(o.startVisible){loopCount=2}else{if(verticalDir){_rePositionVertically()}else{_rePositionHorizontally()}}var animate=function(){if(o.duplicated){if(loopCount===1){o._originalDuration=o.duration;if(verticalDir){o.duration=o.direction==="up"?o.duration+containerHeight/(elHeight/o.duration):o.duration*2}else{o.duration=o.direction==="left"?o.duration+containerWidth/(elWidth/o.duration):o.duration*2}if(animationCss3Str){animationCss3Str=animationName+" "+o.duration/1e3+"s "+o.delayBeforeStart/1e3+"s "+o.css3easing}loopCount++}else if(loopCount===2){o.duration=o._originalDuration;if(animationCss3Str){animationName=animationName+"0";keyframeString=$.trim(keyframeString)+"0 ";animationCss3Str=animationName+" "+o.duration/1e3+"s 0s infinite "+o.css3easing}loopCount++}}if(verticalDir){if(o.duplicated){if(loopCount>2){$marqueeWrapper.css("transform","translateY("+(o.direction==="up"?0:"-"+elHeight+"px")+")")}animationCss={transform:"translateY("+(o.direction==="up"?"-"+elHeight+"px":0)+")"}}else if(o.startVisible){if(loopCount===2){if(animationCss3Str){animationCss3Str=animationName+" "+o.duration/1e3+"s "+o.delayBeforeStart/1e3+"s "+o.css3easing}animationCss={transform:"translateY("+(o.direction==="up"?"-"+elHeight+"px":containerHeight+"px")+")"};loopCount++}else if(loopCount===3){o.duration=o._completeDuration;if(animationCss3Str){animationName=animationName+"0";keyframeString=$.trim(keyframeString)+"0 ";animationCss3Str=animationName+" "+o.duration/1e3+"s 0s infinite "+o.css3easing}_rePositionVertically()}}else{_rePositionVertically();animationCss={transform:"translateY("+(o.direction==="up"?"-"+$marqueeWrapper.height()+"px":containerHeight+"px")+")"}}}else{if(o.duplicated){if(loopCount>2){$marqueeWrapper.css("transform","translateX("+(o.direction==="left"?0:"-"+elWidth+"px")+")")}animationCss={transform:"translateX("+(o.direction==="left"?"-"+elWidth+"px":0)+")"}}else if(o.startVisible){if(loopCount===2){if(animationCss3Str){animationCss3Str=animationName+" "+o.duration/1e3+"s "+o.delayBeforeStart/1e3+"s "+o.css3easing}animationCss={transform:"translateX("+(o.direction==="left"?"-"+elWidth+"px":containerWidth+"px")+")"};loopCount++}else if(loopCount===3){o.duration=o._completeDuration;if(animationCss3Str){animationName=animationName+"0";keyframeString=$.trim(keyframeString)+"0 ";animationCss3Str=animationName+" "+o.duration/1e3+"s 0s infinite "+o.css3easing}_rePositionHorizontally()}}else{_rePositionHorizontally();animationCss={transform:"translateX("+(o.direction==="left"?"-"+elWidth+"px":containerWidth+"px")+")"}}}$this.trigger("beforeStarting");if(css3AnimationIsSupported){$marqueeWrapper.css(animationString,animationCss3Str);var keyframeCss=keyframeString+" { 100%  "+_objToString(animationCss)+"}",$styles=$marqueeWrapper.find("style");if($styles.length!==0){$styles.filter(":last").html(keyframeCss)}else{$("head").append("<style>"+keyframeCss+"</style>")}_prefixedEvent($marqueeWrapper[0],"AnimationIteration",function(){$this.trigger("finished")});_prefixedEvent($marqueeWrapper[0],"AnimationEnd",function(){animate();$this.trigger("finished")})}else{$marqueeWrapper.animate(animationCss,o.duration,o.easing,function(){$this.trigger("finished");if(o.pauseOnCycle){_startAnimationWithDelay()}else{animate()}})}$this.data("runningStatus","resumed")};$this.on("pause",methods.pause);$this.on("resume",methods.resume);if(o.pauseOnHover){$this.on("mouseenter",methods.pause);$this.on("mouseleave",methods.resume)}if(css3AnimationIsSupported&&o.allowCss3Support){animate()}else{_startAnimationWithDelay()}})};$.fn.marquee.defaults={allowCss3Support:true,css3easing:"linear",easing:"linear",delayBeforeStart:1e3,direction:"left",duplicated:false,duration:5e3,speed:0,gap:20,pauseOnCycle:false,pauseOnHover:false,startVisible:false}});
function allSiteMarquee() {
  var widthMarquee = $(window).width();
  if(widthMarquee < 750)
  {
    $('.Index_information_marquee').marquee({
      duration: 20000,
      gap: 0,
      delayBeforeStart: 0,
      direction: 'left',
      duplicated: true,
      startVisible: true
    });
  }
  else
  {
    $('.Index_information_marquee').marquee({
      duration: 55000,
      gap: 0,
      delayBeforeStart: 0,
      direction: 'left',
      duplicated: true,
      startVisible: true
    });
  }
  
  if(widthMarquee < 750)
  {
    $('.Index_text_logo_marquees_marquee').marquee({
      duration: 20000,
      gap: 0,
      delayBeforeStart: 0,
      direction: 'left',
      duplicated: true,
      startVisible: true
    });
  }
  else
  {
    $('.Index_text_logo_marquees_marquee').marquee({
      duration: 55000,
      gap: 0,
      delayBeforeStart: 0,
      direction: 'left',
      duplicated: true,
      startVisible: true
    });
  }

  if(widthMarquee < 750)
  {
    $('.Index_object_instagram_marquee').marquee({
      duration: 20000,
      gap: 0,
      delayBeforeStart: 0,
      direction: 'left',
      duplicated: true,
      startVisible: true
    });
  }
  else
  {
    $('.Index_object_instagram_marquee').marquee({
      duration: 55000,
      gap: 0,
      delayBeforeStart: 0,
      direction: 'left',
      duplicated: true,
      startVisible: true
    });
  }

  if(widthMarquee < 750)
  {
    $('.Index_object_testimonials_marquee').marquee({
      duration: 20000,
      gap: 0,
      delayBeforeStart: 0,
      direction: 'left',
      duplicated: true,
      startVisible: true
    });
  }
  else
  {
    $('.Index_object_testimonials_marquee').marquee({
      duration: 55000,
      gap: 0,
      delayBeforeStart: 0,
      direction: 'left',
      duplicated: true,
      startVisible: true
    });
  }
}
allSiteMarquee()

$(".Tabs_common_inner_new").click(function() {
    var tab_id = $(this).attr("tab_id");
    if ($(this).hasClass("active") == false) {
        $(this).parents(".Tabs_common_main_new").find(".Tabs_common_inner_new").removeClass("active");
        $(this).parents(".Tabs_common_main_new").find(".tabcontent").css("display", "none");

        $(this).addClass("active");
        $(this).parents(".Tabs_common_main_new").find("." + tab_id + "_open").css("display", "block");
    }
})

function initAccordion() {
    $(".accordion .question").click(function() {
        if ($(this).parent("li").hasClass("open") == false) {
            $(this).parents(".accordion").find(".answer").slideUp();
            $(this).parents(".accordion").find("li").removeClass("open");

            $(this).next(".answer").slideDown();
            $(this).parent(".accordion li").addClass("open");
        } else {
            $(this).parents(".accordion").find(".answer").slideUp();
            //$(this).parents(".accordion").find(".answer").css("display", "none");
            $(this).parents(".accordion").find("li").removeClass("open");
        }
    })
}
initAccordion();
document.addEventListener('product-info-accordion:int', initAccordion)

$('.footer-block__details-content .list-unstyled a').on('click', function(event) {
    var target = $(this).attr('href');
    var hash = target.substring(target.indexOf('#') + 1);
    if (hash) {
        $('html, body').stop().animate({
            scrollTop: $("#" + hash).offset().top - 200
        }, 500);

        if ($("#" + hash).hasClass("open") == false) {
            setTimeout(function() {
                $("#" + hash + " .question").trigger("click");
            }, 700)
        }
    }
});

function play_video_on_hover(){
  $(".play_video_on_hover").hover(function(){
    var URL = $(this).find('video').attr("video_url");
    if(!$(this).find('video').attr("src")){
      $(this).find('video').attr("src",URL);  
    }
    $(this).find('video').trigger('play');
  }, function() {
    $(this).find('video').trigger('pause');
  })
}
play_video_on_hover()

/* megamenu */
$(".collection_info_links_new").hover(function(){
  var ID = $(this).attr("menu_id");
  if(ID)
  {
    setTimeout(function(){
      $(".megamenu_right_collection_Info_new").css("display","none");
    	$("."+ID+"_display").css("display","block");
    }, 200);
    $(".collection_info_links_new").removeClass("active");
    $(this).addClass("active");
  }
})

function mobileMenuHeight() {
  var announcementBarHeight = $(".Header_announcement_bar_main_new").outerHeight(true) || 0;
  var headerHeight = $(".header-section").outerHeight(true) || 0;
  var totalHeight = announcementBarHeight + headerHeight;
  $(".menu-drawer").css("top", totalHeight + "px");
  $(".menu-drawer__backdrop").css("top", totalHeight + "px");
  $(".menu-drawer").css("height", "calc(100% - "+totalHeight+"px)");
  $(".search-modal__content").css("top", totalHeight + "px");

  var totalHeightUp = headerHeight - 1;

  $("[data-scroll-direction=up] .menu-drawer").css("top", totalHeightUp + "px");
  $("[data-scroll-direction=up] .menu-drawer__backdrop").css("top", totalHeightUp + "px");
  $("[data-scroll-direction=up] .menu-drawer").css("height", "calc(100% - "+ totalHeightUp +"px)");
  
}
// Run once DOM is ready
$(document).ready(function () {
  mobileMenuHeight();
});
$(".header__icon--menu").click(function () {
  mobileMenuHeight();
});
// Recalculate on resize
$(window).on("resize", mobileMenuHeight);

$(".search-modal__button").click(function () {
  mobileMenuHeight();
});

function initVideoPopup() {
  $(".Index_object_author_open").click(function() {
    var video_id = $(this).attr("video_id");
    if(video_id)
    {
      $(this).parents(".video_play_list_new").find(".video_play_icon_new").removeClass("active");
      $(this).parents(".video_play_list_new").find('video').trigger('pause');
      $(this).parents(".video_play_list_new").find(".play_icon").css("display","block");
      $(this).parents(".video_play_list_new").find(".play_icon_new").removeClass("active");
      
      $("."+video_id+"_open").fadeIn();
      $("."+video_id+"_overlay").fadeIn();
      $('body').addClass("overflow-hidden");
      var URL = $("."+video_id+"_open").find('video').attr("video_url");
      if($("."+video_id+"_open").find('video').attr("src") == null)
      {
        $("."+video_id+"_open").find('video').attr("src",URL);
      }
      $("."+video_id+"_open").find('video').trigger('play');
      $("."+video_id+"_open").find(".video_play_icon_new").addClass("active");
      $("."+video_id+"_open").find(".play_icon").css("display","none");
    }
  })

  $(".mute_video_popup").click(function(){
    $(this).removeClass("active");
    $(this).parents(".Index_object_author_mainpopup_new").find(".unmute_video_popup").addClass("active");
    $(this).parents(".Index_object_author_mainpopup_new").find("video").prop("muted",1)
  })
  $(".unmute_video_popup").click(function(){
    $(this).removeClass("active");
    $(this).parents(".Index_object_author_mainpopup_new").find(".mute_video_popup").addClass("active");
    $(this).parents(".Index_object_author_mainpopup_new").find("video").prop("muted",0)
  })
  $(".Index_object_author_mainclose_new").click(function() {
    $(".Index_object_author_mainpopup_new").fadeOut();
    $(".Index_object_author_overlay_new").fadeOut();
    $('body').removeClass("overflow-hidden");
  
    $(this).parents(".video_play_list_new").find(".video_play_icon_new").removeClass("active");
    $(this).parents(".video_play_list_new").find('video').trigger('pause');
    $(this).parents(".video_play_list_new").find(".play_icon").css("display","block");
    $(this).parents(".video_play_list_new").find(".play_icon_new").removeClass("active");
  })
  $(".Index_object_author_overlay_new").click(function() {
    $(".Index_object_author_mainpopup_new").fadeOut();
    $(".Index_object_author_overlay_new").fadeOut();
    $('body').removeClass("overflow-hidden");
  
    $(this).parents(".video_play_list_new").find(".video_play_icon_new").removeClass("active");
    $(this).parents(".video_play_list_new").find('video').trigger('pause');
    $(this).parents(".video_play_list_new").find(".play_icon").css("display","block");
    $(this).parents(".video_play_list_new").find(".play_icon_new").removeClass("active");
  })
}
initVideoPopup();

function initVideoClick() {
  $(".play_icon_new").click(function(){
    if($(this).hasClass("active") == false)
    {
      $(this).parents(".video_play_list_new").find(".play_icon_new").removeClass("active");
      $(this).parents(".video_play_list_new").find('video').trigger('pause');
      $(this).parents(".video_play_list_new").find(".play_icon").css("display","block");
      //$(this).parents(".video_play_list_new").find(".mute_video_main_new").removeClass("active");
      //$(this).parents(".video_play_list_new").find(".mute_video").addClass("active");
      //$(this).parents(".video_play_list_new").find(".unmute_video").removeClass("active");
      //$(this).parents(".video_play_list_new").find("video").prop("muted",0)
      
      $(this).addClass("active");
      var URL = $(this).find('video').attr("video_url");
      if($(this).find('video').attr("src") == null)
      {
        $(this).find('video').attr("src",URL);
      }
      $(this).find('video').trigger('play');
      $(this).siblings().find('video').trigger('pause');
      $(this).siblings().find('.play_icon').css("display","block");
      $(this).find(".play_icon").css("display","none");
      //$(this).parents(".video_main_block").find(".mute_video_main_new").addClass("active");
    }
    else
    {
      $(this).removeClass("active");
      $(this).find('video').trigger('pause');
      $(this).find(".play_icon").css("display","block");
      //$(this).parents(".video_play_list").find(".mute_video_main_new").removeClass("active");
    }
  })
}
initVideoClick();

document.addEventListener("DOMContentLoaded", function () {
  // Replace this with your actual Klaviyo form ID
  const formSelector = "[data-testid=POPUP]";

  // Watch for Klaviyo form to be added to DOM
  const observer = new MutationObserver(() => {
    const form = document.querySelector(formSelector);
    if (form) {
      const emailInput = form.querySelector('input[type="email"]');
      if (emailInput) {
        emailInput.addEventListener("input", function () {
          this.classList.toggle("typing", this.value.trim() !== "");
        });
        observer.disconnect(); // Stop watching once done
      }
    }
  });

  // Start observing the body for form injection
  observer.observe(document.body, { childList: true, subtree: true });
});

function productPageScript(){

  /* Variant Open */
  $(".product_option_dropdown_title_new").click(function() {
    $(this).parents(".product_option_dropdown_main_new").toggleClass("open_variant");
  })
  $(".product_option_dropdown_inner_new .variant-option__button-label").click(function() {
    $(this).parents(".product_option_dropdown_main_new").removeClass("open_variant");
  })
  $(document).mouseup(function(e) 
  {
      var container = $(".product_option_dropdown_main_new");

      // if the target of the click isn't the container nor a descendant of the container
      if (!container.is(e.target) && container.has(e.target).length === 0) 
      {
          $('.product_option_dropdown_main_new').removeClass("open_variant");
      }
  });

  if($(".Product_information_new").length > 0)
  {
    function buyButtonBlock() {
      $(".buy-buttons-block").css("min-height", "");
      var buy_buttons_block = $(".buy-buttons-block .shopify-product-form").outerHeight(true) || 0;
      $(".buy-buttons-block").css("min-height", buy_buttons_block + "px");
    }
    buyButtonBlock();
    $(window).on("resize", buyButtonBlock);
    
    $(window).scroll(function(){
      var stickyHeaderTopSticky = $(".buy-buttons-block").offset().top + 200;
      if( $(window).scrollTop() > stickyHeaderTopSticky ) {
          if($('body').hasClass("sticky_header_new") == false)
          {
              $('body').addClass("hide_atc_button_new");
              setTimeout(function(){
                $('body').addClass("delay_sticky_header_new");
              }, 100);
              setTimeout(function(){
                $('body').addClass('sticky_header_new');
              }, 400);
          }
      } else {
          if ($('body').hasClass("sticky_header_new")) {
            $('body').removeClass("sticky_header_new");
            setTimeout(function(){
              $('body').removeClass("hide_atc_button_new");
              $("body").removeClass("delay_sticky_header_new");  
            }, 400);
          }
      }
    });
  }
}
productPageScript();
document.addEventListener('product-page-script:init', productPageScript);

/* Header_announcement_bar_slider */
new Swiper('.Header_announcement_bar_slider', {
  loop: true,
  grabCursor: true,
  spaceBetween: 0,
  slidesPerView: 1,
  watchSlidesProgress: true,
  draggable:!0,
  autoHeight:!1,
  watchOverflow:!0,
  threshold:10,
  mousewheel:{
    forceToAxis:!0
  },
  effect: "fade",
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  }
})


/* Index_banner_custom_block_slider */
new Swiper('.Index_banner_custom_block_slider', {
  loop: true,
  grabCursor: false,
  spaceBetween: 10,
  slidesPerGroup: 1,
  slidesPerView: 1,
  watchSlidesProgress: true,
  draggable: !0,
  autoHeight: !1,
  watchOverflow: !0,
  threshold: 10,
  mousewheel: {
      forceToAxis: !0
  },
  observer: true,
  observeParents: true,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  effect: "fade",
  autoplay: {
    delay: 10000,
    disableOnInteraction: false,
  },
  on: {
    // This event fires at the very beginning of the transition
    slideChangeTransitionStart: function () {
      // Get the currently active slide (this.slides[this.activeIndex] is still correct)
      const activeSlide = this.slides[this.activeIndex];
      
      // Get the color from the data-color attribute
      const newColor = activeSlide.getAttribute('data-color');
      
      // Update the CSS custom property on the root element
      document.documentElement.style.setProperty('--active-bullet-color', newColor);
    },
  }
})


/* Index_object_instagram_slider */
new Swiper('.Index_object_instagram_slider', {
  loop: true,
  grabCursor: false,
  spaceBetween: 16,
  slidesPerGroup: 1,
  slidesPerView: "auto",
  watchSlidesProgress: true,
  draggable: !0,
  autoHeight: !1,
  watchOverflow: !0,
  threshold: 10,
  mousewheel: {
      forceToAxis: !0
  },
  freeMode: !0,
  observer: true,
  observeParents: true
})

// Thumbnail slider
var swiperThumbs = new Swiper(".Index_object_tabs_thumb_slider", {
  loop: true,
  grabCursor: true,
  spaceBetween: 16,
  slidesPerView: "auto",
  slideToClickedSlide: true, // Enable click to sync
  watchSlidesProgress: true,
  scrollbar: {
    el: ".swiper-scrollbar",
  },
  breakpoints: {
    0: {
      spaceBetween: 12,
      slidesPerView: 3,
    },
    750: {
      spaceBetween: 16,
      slidesPerView: "auto",
    },
  }
});

// Main slider
var swiperMain = new Swiper(".Index_object_tabs_main_slider", {
  loop: true,
  grabCursor: true,
  spaceBetween: 96,
  slidesPerView: 1,
  draggable: !0,
  autoHeight: 1,
  watchOverflow: !0,
  threshold: 10,
  mousewheel: {
      forceToAxis: !0
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  thumbs: {
    swiper: swiperThumbs,
  },
  breakpoints: {
    0: {
      spaceBetween: 0,
    },
    750: {
      spaceBetween: 50,
    },
    990: {
      spaceBetween: 60,
    },
    1440: {
      spaceBetween: 96,
    }
  }
});



// Link the sliders (thumbs → main)
//swiperMain.controller.control = swiperThumbs;
//swiperThumbs.controller.control = swiperMain;

/* Index_object_detail_items_slider */
new Swiper('.Index_object_detail_items_slider', {
  loop: false,
  grabCursor: false,
  spaceBetween: 18,
  slidesPerGroup: 1,
  slidesPerView: "auto",
  watchSlidesProgress: true,
  draggable: !0,
  autoHeight: !1,
  watchOverflow: !0,
  threshold: 10,
  mousewheel: {
      forceToAxis: !0
  },
  freeMode: !0,
  observer: true,
  observeParents: true
})


/* Index_featured_collection_slider */
new Swiper('.Index_featured_collection_slider', {
  loop: false,
  grabCursor: false,
  spaceBetween: 24,
  slidesPerGroup: 1,
  slidesPerView: "auto",
  watchSlidesProgress: true,
  draggable: !0,
  autoHeight: !1,
  watchOverflow: !0,
  threshold: 10,
  mousewheel: {
      forceToAxis: !0
  },
  freeMode: !0,
  observer: true,
  observeParents: true,
})


/* Product_object_care_guide_slider */
new Swiper('.Product_object_care_guide_slider', {
  loop: false,
  grabCursor: false,
  spaceBetween: 16,
  slidesPerGroup: 1,
  slidesPerView: "auto",
  watchSlidesProgress: true,
  draggable: !0,
  autoHeight: !1,
  watchOverflow: !0,
  threshold: 10,
  mousewheel: {
      forceToAxis: !0
  },
  freeMode: !0,
  observer: true,
  observeParents: true
})
function productMediaListInit () {
  /* Product_object_media_list_slider */
  new Swiper('.Product_object_media_list_slider', {
    loop: true,
    grabCursor: true,
    spaceBetween: 16,
    slidesPerGroup: 1,
    slidesPerView: "auto",
    watchSlidesProgress: true,
    draggable: !0,
    autoHeight: !1,
    watchOverflow: !0,
    threshold: 10,
    mousewheel: {
        forceToAxis: !0
    },
    centeredSlides: true,
    /*freeMode: !0,*/
    observer: true,
    observeParents: true,
    breakpoints: {
      0: {
        centeredSlides: false,
      },
      750: {
        centeredSlides: true,
      },
      990: {
        
      },
      1440: {
        
      }
    }
  })
}
productMediaListInit();
document.addEventListener('product-media-list-slider:init', productMediaListInit)



/* Collection_redirect_lists_slider */
new Swiper('.Collection_redirect_lists_slider', {
  loop: false,
  grabCursor: false,
  spaceBetween: 28,
  slidesPerGroup: 1,
  slidesPerView: 11,
  watchSlidesProgress: true,
  draggable: !0,
  autoHeight: !1,
  watchOverflow: !0,
  threshold: 10,
  mousewheel: {
      forceToAxis: !0
  },
  freeMode: !0,
  observer: true,
  observeParents: true,
  breakpoints: {
    0: {
      spaceBetween: 12,
      slidesPerView: "auto"
    },
    750: {
      spaceBetween: 16,
      slidesPerView: "auto"
    },
    990: {
      spaceBetween: 20,
      slidesPerView: "auto"
    },
    1440: {
      spaceBetween: 28,
      slidesPerView: 11
    }
  }
})



// subscription-rewards slider 
document.addEventListener("DOMContentLoaded", function () {
  if (window.innerWidth <= 749) {
var swiperThumbs = new Swiper(".rewards-right-mobile", {
  loop: false,
  grabCursor: true,
  spaceBetween: 16,
  slidesPerView: 1.299,
  slideToClickedSlide: true, // Enable click to sync
  watchSlidesProgress: true,
  scrollbar: {
    el: ".swiper-scrollbar",
  },
  breakpoints: {
    0: {
      spaceBetween: 16,
    },
    750: {
      spaceBetween: 16,
    },
  }
});
 }
});


// index-object-testimonials-slider
document.addEventListener("DOMContentLoaded", function () {
  var swiperThumbs = new Swiper(".Index_object_testimonials_swiper", {
    loop: false,
    grabCursor: true,
    spaceBetween: 16,
    slidesPerView: 2.444,
    slideToClickedSlide: true,
    watchSlidesProgress: true,
    scrollbar: {
      el: ".swiper-scrollbar",
    },
    mousewheel: {
      forceToAxis: true,  
      releaseOnEdges: false,
      eventsTarget: '.Index_object_testimonials_swiper' 
      },
    breakpoints: {
      0: {
        slidesPerView: 1.479,
        spaceBetween: 16,
      },
      750: {
        spaceBetween: 16,
        slidesPerView: 1.479,
      },
      992: {
        spaceBetween: 16,
        slidesPerView: 1.479,
      },
      1200: {
        spaceBetween: 16,
        slidesPerView: 2.444,
      },
    }
  });
});


//empty_cart_collaction_swiper
  var swiperThumbs = new Swiper(".empty_cart_collaction_swiper", {
    loop: false,
    grabCursor: true,
    spaceBetween: 16,
    slidesPerView: 2.444,
    // slideToClickedSlide: true,
    watchSlidesProgress: true,
    scrollbar: {
      el: ".swiper-scrollbar",
    },
    mousewheel: {
      forceToAxis: true,  
      releaseOnEdges: false,
      eventsTarget: '.empty_cart_collaction_swiper' 
      },
    breakpoints: {
      0: {
        slidesPerView: 2.001,
        spaceBetween: 12,
      },
      750: {
        spaceBetween: 24,
        slidesPerView: 3.001,
      }
    }
  });

  // CWI CODE N
  document.addEventListener('DOMContentLoaded', function() {
    var _url = new URLSearchParams(window.location.search),
        wholesale_text = 'wholesale',
        corporate_gifting_text = 'corporate-gifting';
        
    if(_url.has(wholesale_text)){
      if(document.querySelector('.single_heading[data_text="'+wholesale_text+'"]')){
        document.querySelector('.single_heading[data_text="'+wholesale_text+'"]').click();
        
        setTimeout(() => {
          const url = new URL(window.location);
          url.searchParams.delete(wholesale_text);
          window.history.replaceState({}, '', url.toString());
        }, 200);
      }
    }
    if(_url.has(corporate_gifting_text)){
      if(document.querySelector('.single_heading[data_text="'+corporate_gifting_text+'"]')){
        document.querySelector('.single_heading[data_text="'+corporate_gifting_text+'"]').click();
        
        setTimeout(() => {
          const url = new URL(window.location);
          url.searchParams.delete(corporate_gifting_text);
          window.history.replaceState({}, '', url.toString());
        }, 200);
      }
    }
  });